import '../../../Shared/templates/ErrorPage/ErrorPage.scss'

import { graphql } from 'gatsby'
import * as React from 'react'
import { FunctionComponent } from 'react'
import { getLocalizedData, getLocalizedUrl } from 'Shared/utils/localeURL'
import PuxMetaTags from 'Shared/utils/PuxMetaTags'
import { resolveErrorPage } from 'Shared/utils/resolveErrorPage'
import { useHeaderData } from '../queries/_use-header-data.js'
import { useFooterData } from '../queries/_use-footer-data'

import { BreadcrumbItem } from 'Shared/components/EasySoftwareBreadcrumbs/EasySoftwareBreadcrumbs'
import {
  ErrorPageContent,
  puxErrorPageType,
} from '../../../Shared/templates/ErrorPage/ErrorPage'
import Layout from '../components/core/Layout'
import { IHeaderData } from 'Root/Shared/queries/layout-queries'
import { IPageProperties } from 'Root/Shared/utils/data/buildTypedPage'

export const query = graphql`
  query {
    orchard {
      puxErrorPage(where: { path_contains: "404" }) {
        contentItemId
        localization {
          culture
        }
        errorPageHeading {
          html
        }
        errorPageButton {
          url
          internal
          text
        }
        errorPageImage {
          resizePaths(width: 610, mode: "Min", quality: 80, format: "webp")
          resizePathsMobile(
            width: 327
            mode: "Min"
            quality: 80
            format: "webp"
          )
          resizePathsTablet(
            width: 610
            mode: "Min"
            quality: 80
            format: "webp"
          )
          resizePathsFallback(width: 610, mode: "Min", quality: 75)
          type(first: 1)
          texts
        }
        puxMetaTags {
          metaTagsCanonicalUrl {
            html
          }
          metaTagsDescription {
            html
          }
          metaTagsImage {
            resizePaths(width: 1200, mode: "Min")
          }
          metaTagsKeywords {
            html
          }
          metaTagsOGDescription {
            html
          }
          metaTagsOGImage {
            resizePaths(width: 1200, mode: "Min")
          }
          metaTagsOGTitle {
            html
          }
          metaTagsRobots
          metaTagsStructuredData {
            html
          }
          metaTagsTitle {
            html
          }
        }
      }
    }
  }
`

const page404: FunctionComponent<puxErrorPageType> = (props) => {
  const { isoCode } = getLocalizedData(
    process.env.LOCALE ?? ``,
    process.env.PROJECT ?? ``
  )
  const pageProperties: IPageProperties = {
    hideTrialForm: true,
    pagePropertiesInfoBarBackground: null,
    pagePropertiesInfoBarResetCookieDate: null,
    pagePropertiesInfoBarText: null,
    pagePropertiesVWOEnabled: false,
  }
  const headerData: IHeaderData = {
    menu: [
      {
        menuItemsList: useHeaderData(),
      },
    ],
  }
  const footerData = {
    menu: [
      {
        menuItemsList: useFooterData(),
      },
    ],
  }
  const breadcrumbs: [BreadcrumbItem] = [
    {
      displayText: `404`,
      path: getLocalizedUrl(`${isoCode}/404`),
    },
  ]

  const { pageData: localizedData } = resolveErrorPage(
    props.data?.orchard?.puxErrorPage,
    isoCode,
    getLocalizedUrl(`${isoCode}/`)
  )

  return (
    <Layout
      footerData={footerData}
      headerData={headerData}
      pageContentItemId={localizedData.contentItemId ?? ``}
      pageProperties={pageProperties}
      resStrings={[]}
    >
      <PuxMetaTags {...localizedData.puxMetaTags} />
      <ErrorPageContent breadcrumbs={breadcrumbs} pageData={localizedData} />
    </Layout>
  )
}

export default page404

// import React, { FunctionComponent } from "react";

// const styleGuide: FunctionComponent<any> = (props) => {
//   return (
//     <div></div>
//   )
// }
// export default styleGuide;
